import { useNavigate } from 'react-router-dom'
import FeatureCard from './FeatureCard'

const FEATURES = [
  { icon: '💬', title: 'AI 상담', desc: '고민을 털어놓으세요', tag: '🔥 인기', path: '/counseling' },
  { icon: '🍽️', title: '오늘 뭐 먹지?', desc: '사주로 보는 오늘의 메뉴', tag: '📅 매일', path: '/features/food-today' },
  { icon: '🍀', title: '오늘의 행운', desc: '오늘의 행운 아이템', tag: '📅 매일', path: '/features/lucky-today' },
  { icon: '💑', title: '궁합 분석', desc: '우리 잘 맞을까요?', tag: undefined, path: '/features/compatibility' },
  { icon: '💼', title: '직업 추천', desc: '내 팔자에 맞는 직업은?', tag: undefined, path: '/features/job-recommend' },
  { icon: '👤', title: '유명인 비교', desc: '나와 닮은 유명인은?', tag: undefined, path: '/features/celebrity-match' },
  { icon: '🎴', title: '캐릭터 카드', desc: '내 사주 캐릭터 카드', tag: undefined, path: '/features/character-card' },
  { icon: '🌊', title: '대운 분석', desc: '10년 주기 대운 흐름', tag: undefined, path: '/features/daeun' },
  { icon: '📅', title: '택일(擇日)', desc: '나에게 맞는 길일 찾기', tag: undefined, path: '/features/lucky-date' },
  { icon: '🌙', title: '꿈 해몽', desc: '사주로 풀어보는 꿈의 의미', tag: undefined, path: '/features/dream-interpretation' },
  { icon: '📜', title: '신년운세', desc: '연간 총평·분야별·월별 운세', tag: undefined, path: '/features/yearly-report' },
  { icon: '✍️', title: '이름 풀이', desc: '성명학 분석 + 작명 추천', tag: undefined, path: '/features/name-analysis' },
  { icon: '👥', title: '그룹 궁합', desc: '2~5인 그룹 사주 궁합', tag: undefined, path: '/features/group-compatibility' },
]

export default function FeatureGrid() {
  const navigate = useNavigate()

  return (
    <div>
      <h3 className="font-bold text-[var(--color-text-primary)] text-base mb-3">🛒 오늘 뭐 보실래요?</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {FEATURES.map((f) => (
          <FeatureCard
            key={f.title}
            icon={f.icon}
            title={f.title}
            desc={f.desc}
            tag={f.tag}
            onClick={() => navigate(f.path)}
            disabled={false}
          />
        ))}
      </div>
    </div>
  )
}
